(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-document-type"]) return;
  try {
    
  defer(function () {
    alert("jQuery is now loaded");
  });

  function defer(method) {
    if (window.jQuery) {
      var actions = {
        "factura": function() {
          $(".billing-menu").css("display", "block");
        },
        "boleta": function() {
          $(".billing-menu").css("display", "none");
        }
      }
      $(".document-type-selector").on("change", function() {
        actions[$(this).val()]();
      });

      $('input#rut').on('input', function() {
        var valor = rut.value.replace('.','');
        valor     = valor.replace('-','');
        cuerpo    = valor.slice(0,-1);
        dv        = valor.slice(-1).toUpperCase();
        rut.value = cuerpo + '-'+ dv;
        if(cuerpo.length < 7) {
          $(this).addClass('invalido').removeClass('valido');
          rut.setCustomValidity("RUT Incompleto"); return false;
        } else {
          $(this).addClass('valido').removeClass('invalido');
        }
        suma     = 0;
        multiplo = 2;
        for (i = 1; i <= cuerpo.length; i++) {
          index = multiplo * valor.charAt(cuerpo.length - i);
          suma  = suma + index;
          if (multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
        }
        dvEsperado = 11 - (suma % 11);
        dv         = (dv == 'K') ? 10 : dv;
        dv         = (dv == 0) ? 11 : dv;
        // Validar que el Cuerpo coincide con su Dígito Verificador
        if(dvEsperado != dv) {
          $(this).addClass('invalido').removeClass('valido');
          rut.setCustomValidity("RUT Inválido");
          return false;
        } else {
          $(this).addClass('valido').removeClass('invalido');
        }
        // Si todo sale bien, eliminar errores (decretar que es válido)
        rut.setCustomValidity('');
      });
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-shipping-popup"]) return;
  try {
    
  defer(function () {
    console.log("jQuery is now loaded");
  });

  function defer(method) {
    if (window.jQuery) {
      var true_town = false;
      // selector de regiones
      var cities = {
        "AP": "Arica y Parinacota",
        "TA": "Tarapacá",
        "AN": "Antofagasta",
        "AT": "Atacama",
        "CO": "Coquimbo",
        "VS": "Valparaí­so",
        "RM": "Región Metropolitana",
        "LI": "O'Higgins",
        "ML": "Maule",
        "NB": "Ñuble",
        "BI": "Biobio",
        "AR": "Araucanía",
        "LR": "Los Rí­os",
        "LL": "Los Lagos",
        "AI": "Aysén",
        "MA": "Magallanes"
      };

      // selector de comunas
      var towns = comunas = {
        "AN": ["Antofagasta", "Calama", "María Elena", "Mejillones", "Ollagüe", "San Pedro de Atacama", "Sierra Gorda", "Taltal", "Tocopilla"],
        "AR": ["Angol", "Carahue", "Cholchol", "Collipulli", "Cunco", "Curacautín", "Curarrehue", "Ercilla", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Lonquimay", "Los Sauces", "Lumaco", "Melipeuco", "Nueva Imperial", "Padre las Casas", "Perquenco", "Pitrufquén", "Pucón", "Purén", "Renaico", "Saavedra", "Temuco", "Teodoro Schmidt", "Toltén", "Traiguén", "Victoria", "Vilcún", "Villarrica"],
        "AP": ["Arica", "Camarones", "General Lagos", "Putre"],
        "AT": ["Alto del Carmen", "Caldera", "Chañaral", "Copiapó", "Diego de Almagro", "Freirina", "Huasco", "Tierra Amarilla", "Vallenar"],
        "AI": ["Aisén", "Chile Chico", "Cisnes", "Cochrane", "Coihaique", "Guaitecas", "Lago Verde", "O’Higgins", "Río Ibáñez", "Tortel"],
        "BI": ["Alto Biobío", "Antuco", "Arauco", "Cabrero", "Cañete", "Chiguayante", "Concepción", "Contulmo", "Coronel", "Curanilahue", "Florida", "Hualpén", "Hualqui", "Laja", "Lebu", "Los Álamos", "Los Ángeles", "Lota", "Mulchén", "Nacimiento", "Negrete", "Penco", "Quilaco", "Quilleco", "San Pedro de la Paz", "San Rosendo", "Santa Bárbara", "Santa Juana", "Talcahuano", "Tirúa", "Tomé", "Tucapel", "Yumbel"],
        "CO": ["Andacollo", "Canela", "Combarbalá", "Coquimbo", "Illapel", "La Higuera", "La Serena", "Los Vilos", "Monte Patria", "Ovalle", "Paihuano", "Punitaqui", "Río Hurtado", "Salamanca", "Vicuña"],
        "LL": ["Ancud", "Calbuco", "Castro", "Chaitén", "Chonchi", "Cochamó", "Curaco de Vélez", "Dalcahue", "Fresia", "Frutillar", "Futaleufú", "Hualaihué", "Llanquihue", "Los Muermos", "Maullín", "Osorno", "Palena", "Puerto Montt", "Puerto Octay", "Puerto Varas", "Puqueldón", "Purranque", "Puyehue", "Queilén", "Quellón", "Quemchi", "Quinchao", "Río Negro", "San Juan de la Costa", "San Pablo"],
        "LR": ["Corral", "Futrono", "La Unión", "Lago Ranco", "Lanco", "Los Lagos", "Mariquina", "Máfil", "Paillaco", "Panguipulli", "Río Bueno", "Valdivia"],
        "MA": ["Antártica", "Cabo de Hornos (Ex Navarino)", "Laguna Blanca", "Natales", "Porvenir", "Primavera", "Punta Arenas", "Río Verde", "San Gregorio", "Timaukel", "Torres del Paine"],
        "ML": ["Cauquenes", "Chanco", "Colbún", "Constitución", "Curepto", "Curicó", "Empedrado", "Hualañé", "Licantén", "Linares", "Longaví", "Maule", "Molina", "Parral", "Pelarco", "Pelluhue", "Pencahue", "Rauco", "Retiro", "Romeral", "Río Claro", "Sagrada Familia", "San Clemente", "San Javier", "San Rafael", "Talca", "Teno", "Vichuquén", "Villa Alegre", "Yerbas Buenas"],
        "NB": ["Bulnes", "Chillán", "Chillán Viejo", "Cobquecura", "Coelemu", "Coihueco", "El Carmen", "Ninhue", "Pemuco", "Pinto", "Portezuelo", "Quillón", "Quirihue", "Ránquil", "San Carlos", "San Fabián", "San Ignacio", "San Nicolás", "Treguaco", "Yungay", "Ñiquén"],
        "LI": ["Chimbarongo", "Chépica", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "La Estrella", "Las Cabras", "Litueche", "Lolol", "Machalí", "Malloa", "Marchihue", "Mostazal", "Nancagua", "Navidad", "Olivar", "Palmilla", "Paredones", "Peralillo", "Peumo", "Pichidegua", "Pichilemu", "Placilla", "Pumanque", "Quinta de Tilcoco", "Rancagua", "Rengo", "Requínoa", "San Fernando", "San Vicente", "Santa Cruz"],
        "RM": ["Alhué", "Buin", "Calera de Tango", "Cerrillos", "Cerro Navia", "Colina", "Conchalí", "Curacaví", "El Bosque", "El Monte", "Estación Central", "Huechuraba", "Independencia", "Isla de Maipo", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "María Pinto", "Melipilla", "Padre Hurtado", "Paine", "Pedro Aguirre Cerda", "Peñaflor", "Peñalolén", "Pirque", "Providencia", "Pudahuel", "Puente Alto", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Bernardo", "San Joaquín", "San José de Maipo", "San Miguel", "San Pedro", "San Ramón", "Santiago", "Talagante", "Tiltil", "Vitacura", "Ñuñoa"],
        "TA": ["Alto Hospicio", "Camiña", "Colchane", "Huara", "Iquique", "Pica", "Pozo Almonte"],
        "VS": ["Algarrobo", "Cabildo", "Calera", "Calle Larga", "Cartagena", "Casablanca", "Catemu", "Concón", "El Quisco", "El Tabo", "Hijuelas", "Isla de Pascua", "Juan Fernández", "La Cruz", "La Ligua", "Limache", "Llaillay", "Los Andes", "Nogales", "Olmué", "Panquehue", "Papudo", "Petorca", "Puchuncaví", "Putaendo", "Quillota", "Quilpué", "Quintero", "Rinconada", "San Antonio", "San Esteban", "San Felipe", "Santa María", "Santo Domingo", "Valparaíso", "Villa Alemana", "Viña del Mar", "Zapallar"]
      };

      $("#select-city").append("<option value=''>Select your region</option>");
      $("#select-town").html("<option value=''>Select your Commune</option>");

      // populate cities
      Object.keys(cities).forEach(function(item) {
        $("#select-city").append(
          "<option value='" + item + "' >" + cities[item] + "</option>"
        );
      });

      $("#select-city").on("change", function() {
        populateTowns($(this).val());
      });

      $("#select-town, #select-city").on("change", function() {
        $("form.cart").attr( "action", "/cart?step=contact_information&checkout[shipping_address][country]=CL&checkout[shipping_address][province]=" + $("#select-city").val() + "&checkout[shipping_address][city]=" + $("#select-town").val() );
        $('form.cart input[type=submit][name=checkout].payment').removeClass("payment").unbind();
      });

      $('input[type="submit"]').click(function(evt) {
        true_town = $("." + evt.target.className).data("true-town");
      });

      function closeTownSelector() {
        $(".town-selector-modal").css("display", "none");
      }

      function showTownSelector() {
        $(".town-selector-modal").css("display", "block");
      };

      function populateTowns(city_code) {
        $('#select-town').find('option').remove();
        towns[city_code].forEach(function(item) {
          $("#select-town").append(
            "<option value='" + item + "' >" + item + "</option>"
          );
        });
      }

      // Carrito
      $('.botones .not').click(function(){
        $('.comunas select').removeClass('verde');
        $('.comunas select').addClass('rojo');
        $('.comunas .alert').show(100);
      });

      $('.comunas select').change(function(){
        $('.comunas select').removeClass('rojo');
        $('.comunas select').addClass('verde');
        $('.comunas .alert').hide(100);
        $('.botones .not').hide(100);
      });

      $('form.cart input[type=submit][name=checkout]').addClass("payment").on("click", function() {
        $('#select-city, #select-town').addClass('rojo');
        return false;
      });
    } else {
      setTimeout(function() { defer(method) }, 50);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  $(document).ready(function() {
    $.fn.digits = function() {
      return this.each(function() {
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") );
      })
    };

    update_mini_cart();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function(container_base) {
    var productRecommendationsSection = document.querySelector(container_base);
    if (productRecommendationsSection === null) { return; }
    var productId   = productRecommendationsSection.dataset.productId;
    var baseUrl     = productRecommendationsSection.dataset.baseUrl;
    var sectionType = productRecommendationsSection.dataset.sectionType;
    var limit       = productRecommendationsSection.dataset.limit;
    var requestUrl  = baseUrl + "?section_id=" + sectionType + "&product_id=" + productId + "&limit=" + limit;
    var request     = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload  = function() {
      if (request.status >= 200 && request.status < 300) {
        var container                                         = document.createElement("div");
        container.innerHTML                                   = request.response;
        console.log(container);
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(container_base).innerHTML;
      }
    };
    request.send();
  };

  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === ".product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  loadProductRecommendationsIntoSection(".product-recommendations");

  } catch(e) { console.error(e); }
})();
})();
